import { Api } from './Api'

class BankValidation {
  post (customerId, clearingNumber, bankAccount) {
    const body = {
      clearing_number: clearingNumber.trim(),
      bank_account: bankAccount.trim()
    }
    return fetch(`${Api.getBaseUrl()}bankvalidation/${customerId}`, Api.getOptions('POST', body))
  }
}

export default BankValidation
